<div class="image-chip-container" (click)="onClick()" [class.error]="error">
    <ng-container *ngIf="!error">
        @if (displayText.trim().length === 0) {
            <img class="image-chip" [src]="url" (load)="onLoad()" (error)="onError()" [class.loading]="!loaded"
                [alt]="loaded ? altText : ''" [title]="altText" />
        } @else {
            <span class="display-text">{{ displayText }}</span>
        }
    </ng-container>
    <ng-container *ngIf="error">
        <app-broken-image-icon width="42px" height="42px" color="#F3F3F3" />
    </ng-container>
</div>